import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CtaNhaTuyenDung"] */ "/vercel/path0/src/components/cta-nha-tuyen-dung.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaViecLamGoiY"] */ "/vercel/path0/src/components/cta-viec-lam-goi-y.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaViecLamPhuHop"] */ "/vercel/path0/src/components/cta-viec-lam-phu-hop.tsx");
